import { format } from 'date-fns'
import { useCompanyLocation } from 'hooks/useCompanyLocation'
import styled from 'styled-components'
import { Box, Heading } from 'ui'
import { useShiftEditor } from '../useShiftEditor'
import { previewTokens } from './styles'
import { useAuthContext } from 'components/auth'

const InfoCard = styled(Box)`
  margin: 0 ${previewTokens.spacing.gutter} ${previewTokens.spacing.gap};
  padding: ${previewTokens.spacing.cardPadding};
  border-radius: 14px;
  background: ${previewTokens.colors.infoSurface};
  color: ${previewTokens.colors.infoText};
`

const InfoHeading = styled(Heading)`
  margin: 0;
  color: inherit;
  font-size: 15px;
  font-weight: 600;
  line-height: 20px;
`

const InfoList = styled(Box)`
  margin: 10px 0 0;
  padding-left: 18px;
  list-style: disc outside;
`

const InfoItem = styled(Box)`
  margin: 0 0 8px;
  font-size: 13px;
  line-height: 18px;
  overflow-wrap: anywhere;

  &:last-child {
    margin-bottom: 0;
  }
`

export const OnDemandDeliveryInfo = () => {
  const { shiftData, isOnDemandDeliveryBlock } = useShiftEditor()
  const { company } = useAuthContext()
  const location = useCompanyLocation(shiftData?.details?.locationId)

  if (!isOnDemandDeliveryBlock) return null

  const locationLabel =
    location?.address?.street?.trim() ||
    location?.name?.trim() ||
    'the selected location'
  const selectedDate = shiftData.schedule?.selectedDays?.[0]
  const dateClause = selectedDate
    ? ` on ${format(selectedDate, 'EEE MMM d')}`
    : ''
  const companyName = company?.name?.trim()
  const companyClause = companyName ? ` with the team at ${companyName}` : ''
  const checkInSentence = `Check-in at ${locationLabel}${dateClause}${companyClause}`
  const checkInDescription = /[.!?]$/.test(checkInSentence)
    ? checkInSentence
    : `${checkInSentence}.`

  return (
    <InfoCard>
      <InfoHeading level={4}>What is an On-Demand Delivery?</InfoHeading>
      <InfoList as={'ul'}>
        <InfoItem as={'li'}>{checkInDescription}</InfoItem>
        <InfoItem as={'li'}>
          After check-in, you will be offered 1 or more delivery requests.
        </InfoItem>
      </InfoList>
    </InfoCard>
  )
}
